module.exports = __webpack_public_path__ + "static/media/1019828.a0deaede.jpg";